import React from 'react'
import styled from 'styled-components'
import colors from '../../../styles/colors'
// styles
import theme from '../../../styles/theme'

const Button = ({ className, children, onClick, width, height, radius }) => {
  return (
    <Btn
      type="button"
      className={className}
      onClick={onClick}
      width={width}
      height={height}
      radius={radius}
    >
      {children}
    </Btn>
  )
}

export default Button

const Btn = styled.button`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '38px'};
  font-size: 16px;
  border-radius: ${(props) => props.radius || '8px'};
  background: ${colors.mainG};
  color: #ffff;
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
